import { MDBBtn, MDBCard, MDBCardBody, MDBCol,  MDBRow, MDBAlert } from 'mdbreact';
import React from 'react';
import {  Redirect } from 'react-router-dom';
// import logo from '../../Assets/visaero_logo.png';
import styles from './SetPassword.module.css';
import sha256 from 'sha256';
import axios from '../../authAxios';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import vi_logo from '../../Assets/visaero_logo.png';
import vd_logo from '../../Assets/visadone_logo.png';
import profile_pic_default from '../../Assets/blank-profile-picture.png';
import { mobileNoValidation } from '../Common/Utility/validation';
import { MenuItem, Select } from '@material-ui/core';

// const brand_color = localStorage.getItem('brand_color')
export class SetPassword extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            brand_color :"",
            hidden: true,
            mobile_no: '',
            password: '',
            firstName: '',
            lastName: '',
            isRegistered: false,
            first_name_error_msg: '',
            user_id: '',
            isFirstnameValid: false,
            firstname_error_text: '',

            isLastnameValid: false,
            lastname_error_text: '',

            isMobileNumberValid: false,
            mobile_no_error_text: '',

            isPasswordValid: false,
            password_error_text: '',

            isPolicyAccepted: false,
            logo: '',
            host_name: 'VisaDone',

            error : false,
            errorMsg : "",

            country_code: '91',
            ccode: [],
            country_cioc:'',
        }
        this.handleOptionChange = this.handleOptionChange.bind(this);
    }
    componentDidMount() {
        this.setState({brand_color : localStorage.getItem("brand_color")})

        const host = localStorage.getItem('host');
        if (host == "visaero") {
            this.setState({ logo: vi_logo })
            this.setState({ host_name: 'Visaero' })
        } else if (host == "visadone") {
            this.setState({ logo: vd_logo })
            this.setState({ host_name: 'VisaDone' })
        }
        this.setState({
            user_id: localStorage.getItem("user_id")
        })
        axios
            .get('/brule-engine/getRegistrationCountries?host=' + localStorage.getItem("host"))
            .then(res => {
                    // console.log(res.data.dataobj.data);
                    var countryCodeObj = res.data.dataobj.data.filter((cc) => cc.callingCodes === this.state.country_code)
                    // console.log(countryCodeObj);
                    this.setState({ ccode: res.data.dataobj.data, country_cioc: countryCodeObj[0].cioc })
                })
                .catch((err) => {
                    console.log(err);                
                })
    }

    toggleShow = () => {
        this.setState({ hidden: !this.state.hidden });
    }

    handleFistname = e => {


        if (e.target.value.includes(" ")) {
            e.target.value = e.target.value.replace(/\s/g, "")
        }

        this.setState({
            isFirstnameValid: false,
            firstname_error_text: ""
        })
        this.setState({ firstName: (e.target.value) })
    }



    handleLastname = e => {

        if (e.target.value.includes(" ")) {
            e.target.value = e.target.value.replace(/\s/g, "")
        }

        this.setState({
            isLastnameValid: false,
            lastname_error_text: ""
        })
        this.setState({ lastName: e.target.value })
        // console.log(this.state.lastName.length)
    }
    handleOptionChange(event) {
        // console.log(event.target.value)
        var countryCodeObj = this.state.ccode.filter((c_code) => c_code.cioc === event.target.value)
        // console.log(countryCodeObj[0])

        this.setState({ country_code: countryCodeObj[0].callingCodes, country_cioc: countryCodeObj[0].cioc })
    }
    handlemobile_no = e => {

        if (e.target.value.includes(" ")) {
            e.target.value = e.target.value.replace(/\s/g, "")
        }

        this.setState({
            isMobileNumberValid: false,
            mobile_no_error_text: ""
        })
        this.setState({ mobile_no: e.target.value })
    }

    handlePassword = (e) => {
        this.setState({
            isPasswordValid: false,
            password_error_text: ""
        })
        this.setState({ password: e.target.value })
    }
    handleAcceptPolicy = (e) => {
        console.log("Accept clicked")
        // console.log(e)
        this.setState({
            isPolicyAccepted: !this.state.isPolicyAccepted
        })
    }
    handleUserAgreementClick = (e) => {

    }
    handlePrivacyPolicyClick = (e) => {

    }
    handleContinueBtnClicked = e => {
        console.log('continue btn clicked...')
        // console.log(this.state.firstName)

        if (this.state.firstName.length < 2) {
            this.setState({
                isFirstnameValid: true,
                firstname_error_text: "First name at least 2 characters long."
            })
            return
        }


        // if (this.state.firstName.length > 20){
        //     this.setState({
        //         isFirstnameValid:true,
        //         firstname_error_text:"First name should not be long than 20 character."

        //     })
        //     return
        // }

        if (this.state.lastName.length < 2) {
            this.setState({
                isLastnameValid: true,
                lastname_error_text: "Last name at least 2 characters long."
            })
            return
        }

        // if (this.state.lastName.length > 20  ){
        //     this.setState({
        //         isLastnameValid:true,

        //         lastname_error_text:"Last name should not be long than 20 character."

        //     })
        //     return
        // }



        if (this.state.mobile_no.length < 1) {
            this.setState({
                isMobileNumberValid: true,
                mobile_no_error_text: "mobile number cannot be empty."
            })
            return
        }

        if(mobileNoValidation(this.state.mobile_no) !== ""){
            this.setState({
                isMobileNumberValid : true,
                mobile_no_error_text:mobileNoValidation(this.state.mobile_no)
            })
        }
        

        var pattern = new RegExp(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,20}$/);
        if (!pattern.test(this.state.password)) {
            //alert("Invalid password pattern")
            this.setState({
                isPasswordValid: true,


                password_error_text: "The password must be at least 6 characters long and it must contain atleast one capital case character, atleast one small case character, atleast one number and atleast punctuation"
            })

            return
        }
        if (!this.state.isPolicyAccepted) {
            // alert("Acceptance of user agreement and privacy policy is mandatory")
            this.setState({error : true , errorMsg : "Acceptance of user agreement and privacy policy is mandatory"})
            return
        }

        this.api_RegisterUser()
    }
    api_RegisterUser = e => {
        var convertedPassword = this.state.password
        convertedPassword = sha256(convertedPassword)
        // console.log("convertedPassword")
        // console.log(convertedPassword)
        axios
            .post('/users/updateUserData', {
                "user_id": this.state.user_id,
                //"platform":"web",
                "mobile_no": this.state.mobile_no,
                "country_code":`+${this.state.country_code}`,
                "first_name": this.state.firstName,
                "last_name": this.state.lastName,
                "password": convertedPassword

            },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
            .then((resp) => {
                // console.log(resp)
                if (resp.data.data === "error") {

                    // alert(resp.data.msg)
                    this.setState({error: true , errorMsg : resp.data.msg})

                } else {
                    localStorage.setItem('user_id', resp.data.dataobj._id)
                    localStorage.setItem('base_currency_symbol', resp.data.dataobj.user_preference.default_currency)
                    localStorage.setItem('First_name', resp.data.dataobj.first_name)
                    localStorage.setItem('Last_name', resp.data.dataobj.last_name)
                    localStorage.setItem('session_id', resp.data.dataobj.session_id)
                    localStorage.setItem("profile_pic",profile_pic_default)
                    this.setState({ isRegistered: true })

                }

            }).catch((err)=>{
                console.log(err);
            })

    }

    render() {



        if (this.state.isRegistered) {
            return <Redirect to="/new-visa" />
        }
        return (
            <MDBCard size="sm">
                <MDBCardBody >
                    <div className="text-center">
                        <img  src={this.state.logo} className={localStorage.getItem("host") == "visadone" ? "visadone_logo" : "visaero_logo"  +" img-fluid"}></img>
                    </div>
                    <div className="text-left mt-4">
                        <h3><b>Hello !</b></h3>
                    </div>
                    <div className="text-left">
                        <h5>Welcome to {this.state.host_name}</h5>
                    </div>
                    <div className="text-left" style={{ marginTop: '28%' }}>
                        {/* <MDBInput label="First name" error={this.state.first_name_error_msg} onChange={this.handleFistname} /> */}
                        <TextField
                            style={{ width: '100%' }}
                            error={this.state.isFirstnameValid}
                            id="standard-error-helper-text"
                            label="First name"
                            defaultValue=""
                            value={this.state.first_name}
                            onChange={this.handleFistname}
                            helperText={this.state.firstname_error_text}
                            inputRef={(input) => { this.textInput1 = input; }}
                            autoComplete="off"
                            onKeyDown={this.handleKeyDown}
                        />
                    </div>
                    <div className="text-left" style={{ marginTop: '3%' }}>
                        {/* <MDBInput label="Last name" onChange={this.handleLastname} /> */}
                        <TextField
                            style={{ width: '100%' }}
                            error={this.state.isLastnameValid}
                            id="standard-error-helper-text"
                            label="Last name"
                            defaultValue=""
                            value={this.state.lastName}
                            onChange={this.handleLastname}
                            helperText={this.state.lastname_error_text}
                            inputRef={(input) => { this.textInput2 = input; }}
                            autoComplete="off"
                        />
                    </div>
                    <div className="text-left" style={{ marginTop: '3%' }}>
                        {/* <MDBInput label="mobile_no ID" onChange={this.handlemobile_no} /> */}
                        <MDBRow>
                            <MDBCol size="5" sm="5" md="5" lg="4">
                                <Select style={{ top: '35.5%', width: '100%', textAlign: 'left' }}
                                    onChange={this.handleOptionChange}
                                    value={this.state.country_cioc}
                                >
                                     {
                                    this.state.ccode.map((flag) =>
                                        <MenuItem value={flag.cioc} key={flag.cioc}><img src={flag.flag} id={styles.flagThumbnail} />+{flag.callingCodes}</MenuItem>
                                    )
                                }
                                </Select>
                            </MDBCol >
                            <MDBCol size="7" sm="7" md="7" lg="8">
                        <TextField
                            style={{ width: '100%' }}
                            type='number'
                            error={this.state.isMobileNumberValid}
                            id="standard-error-helper-text"
                            label="Mobile Number"
                            defaultValue=""
                            value={this.state.mobile_no}
                            onChange={this.handlemobile_no}
                            helperText={this.state.mobile_no_error_text}
                            ref={(input) => { this.textInput3 = input; }}
                            />
                            </MDBCol>
                            </MDBRow>
                    </div>
                    <div className="text-left" style={{ marginTop: '3%' }}>
                        {/* <MDBInput type="password" type={this.state.hidden ? 'password' : 'text'} label="Set Password" onChange={this.handlePassword}>
                            <i onClick={this.toggleShow} id="icon" style={{position:'absolute', bottom:'10%',right:'1%'}} className="fa fa-fw fa-eye" />
                        </MDBInput> */}
                        <MDBRow>
                            <MDBCol>
                                <TextField
                                    type={this.state.hidden ? 'password' : 'text'}
                                    style={{ width: '100%' }}
                                    error={this.state.isPasswordValid}
                                    id="standard-error-helper-text"
                                    label="Set password"
                                    defaultValue=""
                                    value={this.state.password}
                                    onChange={this.handlePassword}
                                    helperText={this.state.password_error_text}
                                    autoComplete={false}

                                /> 
                                {this.state.hidden ? 
                                <i onClick={this.toggleShow} id="icon" style={{ position: 'absolute', cursor : "pointer" , bottom: '15%', right: '3%' }} className="fa fa-fw fa-eye-slash" />
                                :
                                <i onClick={this.toggleShow} id="icon" style={{ position: 'absolute', cursor : "pointer" , bottom: '15%', right: '3%' }} className="fa fa-fw fa-eye" />
                                }
                            </MDBCol> </MDBRow>
                    </div>
                    <div className="text-left mt-4">
                        <MDBRow>
                            <MDBCol size="1" sm="1" md="1" lg="1">
                                <Checkbox
                                    checked={this.state.isPolicyAccepted}
                                    onChange={this.handleAcceptPolicy}
                                    color='primary'
                                    style={{ marginLeft: '0', marginTop: '-8px' }}
                                />
                            </MDBCol>
                            <MDBCol size="11" sm="11" md="11" lg="11" style={{ color: 'gray' }}>I confirm that I have read,
                            consent & agree to {this.state.host_name.toUpperCase()}&nbsp;
      <a href="#" id={styles.policyLink} onClick={this.handleUserAgreementClick} >User Agreement</a>
      &nbsp;& <a href="#" id={styles.policyLink} onClick={this.handlePrivacyPolicyClick}>Privacy policy.</a>
                            </MDBCol>

                        </MDBRow>
                    </div>

                    <div className="mb-2 mt-2">
                        <MDBBtn id={styles.logoutBtn} style={{ backgroundColor: this.state.brand_color }} color="none" onClick={this.handleContinueBtnClicked}>Continue</MDBBtn>
                    </div>
                    {this.state.error &&
                    <MDBAlert color="danger">{this.state.errorMsg} </MDBAlert>
                    }
                </MDBCardBody>
            </MDBCard>
        );
    }
};

export default SetPassword;